import { useRef } from 'react';
import { CrudForm } from '../../../../containers/crud/crudForm';
import { ApiAutoCompleteSelect } from '../../../../containers/selectComponents/apiAutoCompleteSelect';

export const WebsitesForm = (props) => {
  const form = useRef(null);

  return (
    <CrudForm
      {...props}
      ref={form}
      elements={[
        {
          type: 'text',
          name: 'name',
          label: 'Name',
          required: true,
        },
        {
          type: 'custom',
          name: 'websiteTemplateId',
          label: 'Website Template',
          required: true,
          Component: ApiAutoCompleteSelect,
          inputProps: {
            api: 'website-template',
            params: {
              all: true,
              search: (text) => [`name;${text};like`],
            },
          },
        },
        {
          type: 'custom',
          name: 'userId',
          label: 'User',
          required: true,
          Component: ApiAutoCompleteSelect,
          inputProps: {
            api: 'users',
            params: {
              search: (text) => [
                `displayName;${text};like`,
                `email;${text};like`,
              ],
              operator: 'or',
              role: 'user',
              all: true,
            },
            formatter: ({ key, name, email }) => ({
              label: `${name} ${email && `(${email})`} `,
              value: key,
            }),
          },
        },
      ]}
    />
  );
};
